<script lang="ts">
  import type { Link } from "$lib/i18n/util"
  import { Button, Dialog } from "@tastyworks/ui-library"
  import type { Snippet } from "svelte"

  interface Props {
    open?: boolean
    title?: string | undefined
    description?: string | undefined
    link?: Link | undefined
    isHtml?: boolean
    titleSnippet?: Snippet
    descriptionSnippet?: Snippet
    onClose?: () => void
    [key: string]: any
  }

  let {
    open = $bindable(true),
    title = undefined,
    description = undefined,
    link = undefined,
    isHtml = false,
    titleSnippet,
    descriptionSnippet,
    onClose,
    ...rest
  }: Props = $props()

  $effect(() => {
    if (!open) {
      onClose?.()
    }
  })
</script>

<Dialog.Root {...rest} bind:open variant="confirmation">
  <Dialog.Portal>
    <Dialog.Overlay />

    <Dialog.Content>
      <Dialog.Title
        class="font-xlarge-650 text-general-secondary-text flex justify-between"
        data-testid="informational-dialog-title"
      >
        {#if titleSnippet}{@render titleSnippet()}{:else}
          {title}
        {/if}
        <Dialog.Close />
      </Dialog.Title>

      <Dialog.Description data-testid="informational-dialog-description">
        {#if descriptionSnippet}{@render descriptionSnippet()}{:else if isHtml}
          {@html description}
        {:else}
          {description}
        {/if}
        {#if link}
          <Button variant="link" href={link.href} class="mt-4 block">
            {link.text}
          </Button>
        {/if}
      </Dialog.Description>
    </Dialog.Content>
  </Dialog.Portal>
</Dialog.Root>
